export interface InstagramCatalogOption {
  readonly value: string;
  readonly label: string;
}

/** Default post type values for Instagram destination defaults (`InstagramPostType` on backend). */
export const INSTAGRAM_POST_TYPES: readonly InstagramCatalogOption[] = Object.freeze([
  { value: 'Reel', label: 'Reel' },
  { value: 'Story', label: 'Story' },
]);

export const INSTAGRAM_DEFAULT_POST_TYPE = 'Reel';
